"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var IncompletedocumentationController = function IncompletedocumentationController($scope, DTOptionsBuilder, DTColumnBuilder, Constants, CONST, User, FunctionService, materialButtons, datePicker, $rootScope, $sanitize, CoderService, ModalService) {
  _classCallCheck(this, IncompletedocumentationController);

  this.user = User.getUser();
  this.datatableApi;
  this.name = "Incomplete Documentation";
  this.specialtyString = "";
  this.separationString = "";

  // Start of financial year
  var yearOfStartDate = new Date().getMonth() < 6 ? new Date().getFullYear() - 1 : new Date().getFullYear();
  var startDate = new Date(yearOfStartDate, 6, 1);

  this.startDate = moment(startDate).format("DD/MM/YYYY");
  this.endDate = moment().format("DD/MM/YYYY");
  this.locale = "en-au";
  this.url = WEBSERVICEURL + "/dataagility/api/service.incompletedocumentation";
  this.startDatePicker = {
    input: {
      date: moment($scope.vm.startDate, "DD/MM/YYYY").locale($scope.vm.locale),
      dateFormatted: $scope.vm.startDate
    }
  };
  this.endDatePicker = {
    input: {
      date: moment($scope.vm.endDate, "DD/MM/YYYY").locale($scope.vm.locale),
      dateFormatted: $scope.vm.endDate
    }
  };
  this.dischargeUnit = {
    selectedDischargeUnit: []
  };
  this.dischargeUnitOptions = {};
  this.campus = {
    selectedCampus: []
  };
  this.campusOptions = {};
  this.hasOutstandingDocuments = "";
  this.outstandingDocsOptions = [{ value: true, label: "Open" }, { value: false, label: "Completed" }, { value: "", label: "Open & Completed" }];
  this.hasOutstandingDocumentsId = "";

  this.coder = {
    selectedCoder: []
  };
  this.coderOptions = [];
  this.coderOptionsWithIds = {};
  this.selectedCoderIds = [];

  this.createdBy = {
    selectedCreatedBy: [],
    selectedCreatedByIds: []
  };
  this.createdByOptions = [];
  this.createdByOptionsWithIds = [];

  this.docType = {
    selectedDocType: []
  };
  this.docTypeOptions = [];

  this.dateTypeDefaultId = 1;
  this.dateTypeOptions = [{ id: 0, value: "Date Created" }];
  this.dateType = { id: this.dateTypeDefaultId };

  FunctionService.getFunctions($rootScope.globals.currentUser.roleId).then(function (response) {
    $scope.vm.separationString = response.functionSettings.SeparationString.valueString;
    $scope.vm.specialtyString = response.functionSettings.SpecialtyString.valueString;
    $scope.vm.functionSettings = response.functionSettings;

    var option = {
      id: $scope.vm.dateTypeDefaultId,
      value: $scope.vm.separationString + " Date"
    };
    $scope.vm.dateTypeOptions.push(option);
    $scope.vm.dateType = $scope.vm.dateTypeOptions[1];
    $scope.vm.selectedDateTypeId = $scope.vm.dateTypeOptions[1].id;

    Constants.campusData().then(function successCallback(response) {
      if ($scope.vm.user.role !== "Administrator" && $scope.vm.functionSettings.LimitCampusDropDown && $scope.vm.functionSettings.LimitCampusDropDown.isActive) {
        var campusOptions = [];
        if (typeof $scope.vm.user.campus === "string") {
          campusOptions = unescape($scope.vm.user.campus).split(","); // tslint:disable-line
        } else {
          if ($scope.vm.user.campus === undefined) {
            campusOptions = [];
          } else {
            campusOptions = unescape($scope.vm.user.campus.join()).split(","); // tslint:disable-line
          }
        }
        $scope.vm.campusOptions = campusOptions;
        $scope.vm.campus.selectedCampus = campusOptions;
      } else {
        $scope.vm.campusOptions = response;
      }
    });
  });

  CoderService.data().then(function successCallback(response) {
    angular.forEach(response, function (item, key) {
      $scope.vm.coderOptions.push(item.name);
      $scope.vm.coderOptionsWithIds[item.name] = item.id;
      $scope.vm.createdByOptions.push(item.name);
      $scope.vm.createdByOptionsWithIds[item.name] = item.id;
    });
  });

  ModalService.getIncDocTypes().then(function (response) {
    angular.forEach(response.INCDOCTYPES, function (item, key) {
      if (item.isActive && item.toggleModalTypeId === 2) {
        $scope.vm.docTypeOptions.push(item.toggleLabel);
      }
    });
    $scope.vm.docTypeOptions.push("Dummy Coded");
    $scope.vm.docTypeOptions.sort();
  });

  Constants.getDivisionAndSpecialtyData().then(function successCallback(response) {
    $scope.vm.dischargeUnitOptions = response.specialties;
  });

  datePicker.autoClose($scope);

  materialButtons.render();

  materialButtons.processing();

  $scope.initCallback = function () {
    // Datatables has finished init
    // Initialise searching
    if ($scope.vm.datatableApi) return;

    $scope.vm.datatableApi = this.api();

    // Update column headers even when no data returned
    setDtHeaders($scope.vm.datatableApi);

    search();

    // Set the table to a fixed height, so it never collapses up or down
    $("#auditTable").closest(".dataTables_scrollBody").height(300);
  };

  $scope.drawCallback = function (nRow) {
    // Tell DataTables we're using Aussie-formatted dates for ordering
    $.fn.dataTable.moment("DD/MM/YYYY HH:mm");
  };

  this.dtOptions = DTOptionsBuilder.newOptions().withOption("ajax", {
    headers: {
      Authorization: "Bearer " + $rootScope.globals.currentUser.token
    },
    url: $scope.vm.url + "?startDate=" + this.startDatePicker.input.dateFormatted + "&endDate=" + this.endDatePicker.input.dateFormatted + "" + "&dateType=" + this.dateType.id,
    type: "GET",
    error: function error(xhr, _error, thrown) {
      if (thrown == "Unauthorized") {
        //window.location.replace(window.location.origin + '/login');
        console.log("Unauthorized request with token: ", $rootScope.globals.currentUser.token);
      }
    }
  }).withDisplayLength(CONST.TABLEROWS).withDataProp("data").withOption("processing", true).withOption("sAjaxDataProp", "").withOption("bLengthChange", false).withPaginationType("simple_numbers").withOption("rowCallback", function (row, data, index) {
    // Update column headers if data returned
    setDtHeaders($("#auditTable").DataTable());
  }).withOption("rowCallback", $scope.rowCallback).withOption("drawCallback", $scope.drawCallback).withOption("initComplete", $scope.initCallback).withOption("scrollY", "300px").withOption("scrollX", "auto").withOption("aaSorting", [[0, "asc"]]).withOption("dom", '<"wrapper"rt<"table-footer"iBp>>').withButtons([{
    extend: "print",
    text: ""
  }, {
    extend: "csvHtml5",
    text: "",
    filename: $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm")
  }, {
    extend: "excelHtml5",
    text: "",
    filename: $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm")
  }, {
    text: "",
    action: function action(e, dt, node, config) {
      dt.ajax.reload();
    }
  }]);

  this.dtColumns = [DTColumnBuilder.newColumn("campus").withTitle("Campus").withOption("defaultContent", "").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("urn").withOption("defaultContent", "").withTitle("URN").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("episodeNumber").withOption("defaultContent", "").withTitle("Episode Number").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("admissionDate").withOption("defaultContent", "").withTitle("Admission Date").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("dischargeDate").withOption("defaultContent", "").withTitle("Loading...").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("dischargeUnit").withOption("defaultContent", "").withTitle("Loading...").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("clinician").withOption("defaultContent", "").withTitle("Clinician").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("originalCoder").withOption("defaultContent", "").withTitle("Original Coder").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("documentationType").withOption("defaultContent", "").withTitle("Documentation Type").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("createdBy").withOption("defaultContent", "").withTitle("Created By").withClass("mdl-data-table__cell--non-numeric"), DTColumnBuilder.newColumn("commentsDate").withOption("defaultContent", "").withTitle("Created Date").withClass("mdl-data-table__cell--non-numeric").renderWith(function (data, type, full) {
    var date = moment(data).format("DD/MM/YYYY HH:mm");
    if (date === "Invalid date") {
      date = "";
    }
    return date;
  }), DTColumnBuilder.newColumn("comments").withOption("defaultContent", "").withTitle("Comments").withClass("mdl-data-table__cell--non-numeric").renderWith(function (data, type, full) {
    return $sanitize(full.comments);
  }), DTColumnBuilder.newColumn("completedDttm").withOption("defaultContent", "").withTitle("Completed Date").withClass("mdl-data-table__cell--non-numeric").renderWith(function (data, type, full) {
    var date = moment(data).format("DD/MM/YYYY HH:mm");
    if (date === "Invalid date") {
      date = "";
    }
    return date;
  }), DTColumnBuilder.newColumn("hasOutstandingDocumentation").withOption("defaultContent", "").withTitle("Incomplete Documentation").withClass("mdl-data-table__cell--non-numeric")];

  this.dischargeUnitCallback = dischargeUnitCallback;

  function dischargeUnitCallback(_newValue, _oldValue) {
    $scope.vm.changeData();
  }

  function setDtHeaders(table) {
    $(table.column(4).header()).html($scope.vm.separationString + " Date");
    $(table.column(5).header()).html($scope.vm.specialtyString);
  }

  this.filterDischargeUnit = filterDischargeUnit;

  function filterDischargeUnit(swap) {
    $scope.vm.dischargeUnit.selectedDischargeUnit = [];
    if (swap === "add") {
      $scope.vm.dischargeUnit.selectedDischargeUnit = $scope.vm.dischargeUnitOptions;
    }
  }

  this.filterCoder = filterCoder;

  function filterCoder(swap) {
    $scope.vm.coder.selectedCoder = [];
    if (swap === "add") {
      $scope.vm.coder.selectedCoder = coderOptions;
    }
  }

  this.filterCreatedBy = filterCreatedBy;

  function filterCreatedBy(swap) {
    $scope.vm.createdBy.selectedCreatedBy = [];
    $scope.vm.createdBy.selectedCreatedByIds = [];
    if (swap === "add") {
      angular.forEach($scope.vm.createdByOptions, function (value, key) {
        $scope.vm.createdBy.selectedCreatedBy.push($scope.vm.createdByOptions[$scope.vm.createdByOptions.indexOf(value)]);
      });
    }
  }

  this.campusCallback = campusCallback;

  function campusCallback(_newValue, _oldValue) {
    $scope.vm.changeData();
  }

  this.coderCallback = coderCallback;

  function coderCallback(_newValue, _oldValue) {
    $scope.vm.changeData();
  }

  this.filterCampus = filterCampus;

  function filterCampus(modifier) {
    $scope.vm.campus.selectedCampus = []; // In case minus was clicked
    if (modifier === "add") {
      $scope.vm.campus.selectedCampus = $scope.vm.campusOptions; // If minus wasn't clicked, assign all the values
    }
  }

  this.docTypeCallback = docTypeCallback;

  function docTypeCallback(_newValue, _oldValue) {
    $scope.vm.changeData();
  }

  this.filterDocType = filterDocType;

  function filterDocType(swap) {
    $scope.vm.docType.selectedDocType = [];
    if (swap === "add") {
      $scope.vm.docType.selectedDocType = $scope.vm.docTypeOptions;
    }
  }

  this.filterIncompleteDocumentation = filterIncompleteDocumentation;

  function filterIncompleteDocumentation(swap) {
    $scope.vm.hasOutstandingDocuments = "";
    if (swap === "add") {
      $scope.vm.hasOutstandingDocuments = "Open & Completed";
    }
  }

  this.outstandingDocsCallback = outstandingDocsCallback;

  function outstandingDocsCallback(_newValue, _oldValue) {
    $scope.vm.hasOutstandingDocuments = _newValue;
    $scope.vm.hasOutstandingDocumentsId = _newValue.value;
    $scope.vm.hasOutstandingDocumentsValue = _newValue.label;
    $scope.vm.changeData();
  }

  function checkParam(param) {
    if (param !== undefined && param.length !== 0) {
      return encodeURIComponent(param.join());
    } else {
      return "";
    }
  }

  this.changeData = changeData;

  function changeData() {
    var campus = "";
    if ($scope.vm.functionSettings.LimitCampusDropDown && $scope.vm.functionSettings.LimitCampusDropDown.isActive) {
      if ($scope.vm.user.role !== "Administrator" && $scope.vm.campus.selectedCampus.length === 0) {
        campus = $scope.vm.user.campus;
      } else {
        campus = $scope.vm.campus.selectedCampus;
      }
    } else {
      campus = $scope.vm.campus.selectedCampus;
    }
    var startDate = $scope.vm.startDatePicker.input.dateFormatted,
        endDate = $scope.vm.endDatePicker.input.dateFormatted,
        selectedDateType = $scope.vm.selectedDateTypeId,
        selectedDischargeUnit = $scope.vm.dischargeUnit.selectedDischargeUnit,
        selectedCoder = $scope.vm.coder.selectedCoder,
        selectedCoderIds = $scope.vm.selectedCoderIds,
        selectedCreatedBy = $scope.vm.createdBy.selectedCreatedBy,
        selectedCreatedByIds = $scope.vm.createdBy.selectedCreatedByIds,
        hasOutstandingDocuments = $scope.vm.hasOutstandingDocumentsId,
        selectedDocType = $scope.vm.docType.selectedDocType,
        newUrl = $scope.vm.url + "?startDate=" + startDate + "&endDate=" + endDate + "&dateType=" + selectedDateType + "&dischargeUnit=" + checkParam(selectedDischargeUnit) + "&coder=" + checkParam(selectedCoder) + "&coderIds=" + checkParam(selectedCoderIds) + "&createdBy=" + checkParam(selectedCreatedBy) + "&createdByIds=" + checkParam(selectedCreatedByIds) + "&campus=" + checkParam(campus) + "&hasOutstandingDocuments=" + hasOutstandingDocuments + "&docType=" + checkParam(selectedDocType);

    $scope.vm.datatableApi.ajax.url(newUrl).load().draw();
  }

  function search() {
    filterDischargeUnit("minus");
    filterCoder("minus");
    filterCampus("minus");

    $scope.$on("lx-date-picker__close-start", function (e, id) {
      $scope.vm.changeData();
    });
  }

  this.setDateType = setDateType;

  function setDateType(newValue) {
    $scope.vm.dateType = newValue;
    $scope.vm.selectedDateTypeId = newValue.id;
    $scope.vm.selectedDateTypeValue = newValue.value;
    $scope.vm.changeData();
  }

  this.setCoder = setCoder;

  function setCoder(newValue) {
    $scope.vm.selectedCoder = newValue;
    if ($scope.vm.selectedCoder.length) {
      $scope.vm.selectedCoderIds = [];
      angular.forEach($scope.vm.selectedCoder, function (model, index) {
        $scope.vm.selectedCoderIds.push($scope.vm.coderOptionsWithIds[model]);
      });
    } else {
      $scope.vm.selectedCoderIds = [];
    }
    $scope.vm.changeData();
  }

  this.setCreatedBy = setCreatedBy;

  function setCreatedBy(newValue) {
    $scope.vm.selectedCreatedBy = newValue;

    $scope.vm.createdBy.selectedCreatedByIds = [];
    angular.forEach($scope.vm.selectedCreatedBy, function (model) {
      $scope.vm.createdBy.selectedCreatedByIds.push($scope.vm.createdByOptionsWithIds[model]);
    });

    $scope.vm.changeData();
  }

  // Bind the datatable instance to an object to monitor loading
  this.dtInstanceCallback = dtInstanceCallback;

  function dtInstanceCallback(dtInstance) {
    $scope.dtInstance = dtInstance._renderer;
  }
};

exports.default = IncompletedocumentationController;


// WEBPACK FOOTER //
// ./client/app/common/reports/incompletedocumentation/incompletedocumentation.controller.js